
  var _styles = {
  "team-won-free-card-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "textAlign": "center",
    "maxWidth": "2.98667rem"
  },
  "team-won-free-card-title-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.26667rem"
  },
  "team-won-free-card-title-container-bottom": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.08rem"
  },
  "team-won-free-card-title-container-bottom-text": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "team-won-free-card-content-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.84rem"
  },
  "team-won-free-card-content-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.64rem",
    "textAlign": "center",
    "color": "rgb(17,17,17)"
  },
  "team-won-free-card-content-text-desc": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginTop": "0.13333rem"
  },
  "team-won-free-card-buttons-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "9.36rem",
    "paddingTop": 0,
    "paddingRight": "0.4rem",
    "paddingBottom": 0,
    "paddingLeft": "0.4rem",
    "marginTop": "0.65333rem"
  }
};



  module.exports = _styles;
  